/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Card_DescInputs */

const en_admin_dashboard_card_desc = /** @type {(inputs: Admin_Dashboard_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin area for system management.`)
};

const de_admin_dashboard_card_desc = /** @type {(inputs: Admin_Dashboard_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Bereich für Systemverwaltung.`)
};

/**
* | output |
* | --- |
* | "Admin area for system management." |
*
* @param {Admin_Dashboard_Card_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_dashboard_card_desc = /** @type {((inputs?: Admin_Dashboard_Card_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Card_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_dashboard_card_desc(inputs)
	return en_admin_dashboard_card_desc(inputs)
});